<template>
  <v-container fluid>
    <v-row v-if="true" class="mt-16"></v-row>
    <!-- <v-row v-if="!mostrarMargenSuperior" class="mt-16"></v-row> -->
    <v-row>
      <v-col cols="12" v-if="logedInUserInfo.rol == 1">
        <editor
          v-if="reloadEditor"
          ref="toastuiEditor"
          :options="editorOptions"
          :initialEditType="'wysiwyg'"
          :initialValue="valorContrato"
        />
        <v-btn
          class="mt-2"
          block
          color="blue darken-1"
          style="color:white;"
          elevation="5"
          @click="actualizaContrato()"
        >
          ACTUALIZAR CONTRATO
        </v-btn>
      </v-col>
      <v-col cols="12">
        <span v-if="logedInUserInfo.rol == 1" style="font-weight:bold;"
          >VISTA CONTRATO CLIENTE</span
        >
        <span v-html="contratoText[0].TEXTO"> </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col  lg="2">

      </v-col>
      <v-col cols="12" lg="8">
      <v-img
        alt="IPS Contrato"          
        src="../assets/contratoIPScomprimido.jpg"        
      >
      </v-img>
      </v-col>
      <v-col cols="0" lg="2"></v-col>
    </v-row>
    
  </v-container>
</template>
<script>
import "codemirror/lib/codemirror.css";
import "@toast-ui/editor/dist/toastui-editor.css";

import { Editor } from "@toast-ui/vue-editor";
import { mapActions, mapState } from "vuex";
export default {
  components: {
    editor: Editor
  },
  data: () => ({
    reloadEditor: false,
    editorOptions: {
      hideModeSwitch: true
    },
    valorContrato: ""
  }),
  methods: {
    ...mapActions("contrato", ["getContrato", "editContrato"]),
    async actualizaContrato() {
      let html = this.$refs.toastuiEditor.invoke("getHtml");
      this.valorContrato = html.replace(/\n|\r/g, "");
      await this.editContrato({ Id: 1, Texto: this.valorContrato });
      await this.obtenContrato();
    },

    async obtenContrato() {
      await this.getContrato();
      this.valorContrato = this.contratoText[0].TEXTO;
      this.reloadEditor = true;
    }
  },
  async mounted() {
    await this.obtenContrato();
  },
  computed: {
    ...mapState("contrato", {
      contratoText: state => state.contrato
    }),
    ...mapState({
      logedInUserInfo: state => state.sesion.logedInUserInfo
    }),
    mostrarMargenSuperior() {
      if (
        this.$store.state.sesion.logedInUserTokens.accesstoken == null ||
        this.$store.state.sesion.logedInUserTokens.accesstoken == ""
      ) {
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>
